import { LinkType } from 'constants/LinkType';
import { useTranslation } from 'react-i18next';
import { EMPLOYEES__LINK_TYPE_APPLICATION, EMPLOYEES__LINK_TYPE_ONBOARDING } from 'translations/constants';
import { LinkTypeBadgeStyled } from './styles';

interface ILinkTypeBadgeProps {
  linkType: LinkType;
}

/**
 * Single source of truth for the badge text. Shared with the column-width measurement so the
 * width can never be computed from different strings than the ones actually rendered.
 */
export const getLinkTypeLabel = (linkType: LinkType, t: (key: string) => string): string =>
  linkType === LinkType.Application ? t(EMPLOYEES__LINK_TYPE_APPLICATION) : t(EMPLOYEES__LINK_TYPE_ONBOARDING);

/** Type indicator for a row in the merged Active links grid. */
const LinkTypeBadge = (props: ILinkTypeBadgeProps): JSX.Element => {
  const { linkType } = props;
  const [t] = useTranslation();

  return (
    <LinkTypeBadgeStyled isApplication={linkType === LinkType.Application}>
      {getLinkTypeLabel(linkType, t)}
    </LinkTypeBadgeStyled>
  );
};

export default LinkTypeBadge;
